
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24","fill":"#5f6368"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M456-600h320q-27-69-82.5-118.5T566-788L456-600zm-92 80l160-276q-11-2-22-3t-22-1q-66 0-123 25t-101 67l108 188zM170-400h218L228-676q-32 41-50 90.5T160-480q0 21 2.5 40.5T170-400zm224 228l108-188H184q27 69 82.5 118.5T394-172zm86 12q66 0 123-25t101-67L596-440 436-164q11 2 21.5 3t22.5 1zm252-124q32-41 50-90.5T800-480q0-21-2.5-40.5T790-560H572l160 276zM480-480zm0 400q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80z"}})])
          )
        }
      }
    